import { CurrencyApi } from '@voladeum/client';
import { FORMAT_TYPE } from 'cyprus/enums';
import { formatValue } from 'cyprus/formats';
import { v4 as uuidv4 } from 'uuid';

import { Currency } from './types';

export const normalizeCurrencies = (data: CurrencyApi[]): Currency[] =>
  data.map((d) => normalizeCurrency(d));

export const normalizeCurrency = (row: CurrencyApi): Currency => {
  return {
    ...row,
    market_cap_formatted: formatValue(row.market_cap, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    market_cap_change_formatted: formatValue(row.market_cap_change, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    market_cap_rank_formatted: formatValue(row.market_cap_rank, { format: FORMAT_TYPE.NUMBER }),
    total_supply_formatted: formatValue(row.total_supply, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    max_supply_formatted: formatValue(row.max_supply, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    circulating_supply_formatted: formatValue(row.circulating_supply, {
      format: FORMAT_TYPE.NUMBER_ABBREVIATED,
      decimal: 1,
    }),
    uuid: uuidv4(),
  };
};
